// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var EnrollPatientCaseInitiator;
(function (EnrollPatientCaseInitiator) {
    EnrollPatientCaseInitiator["hub"] = "hub";
    EnrollPatientCaseInitiator["patient"] = "patient";
    EnrollPatientCaseInitiator["pharmacy"] = "pharmacy";
    EnrollPatientCaseInitiator["provider"] = "provider";
    EnrollPatientCaseInitiator["quickpath"] = "quickpath";
})(EnrollPatientCaseInitiator || (EnrollPatientCaseInitiator = {}));
//# sourceMappingURL=enrollPatientCaseInitiator.js.map